<div class="activity-parent" (scroll)="calcInfiniteScroll()">
  <div class="activity" #activity>
    <h1>Gallery Activity</h1>
    <div class="buttons">
      @if (!loading()) {
        <button
          appButton
          name="mark-all-as-read"
          location="gallery-activity-menu"
          color="simple-gray-70"
          class="mark-as-read"
          [hasIcon]="true"
          height="0"
          spacing="1"
          (click)="markAllAsSeen()"
          [class.disabled]="!onOpenNewCount()"
        >
          @if (onOpenNewCount()) {
            <app-svg size="0" [class.hidden-text]="markingAllAsSeen()" src="/assets/icons/check-circle.svg"></app-svg>
          } @else {
            <app-svg size="0" [class.hidden-text]="markingAllAsSeen()" src="/assets/icons/check-outline.svg"></app-svg>
          }
          <span [class.hidden-text]="markingAllAsSeen()">Mark as read</span>
          @if (markingAllAsSeen()) {
            <app-loading-indicator color="grey-70" size="small" class="button-loading-indicator">
            </app-loading-indicator>
          }
        </button>
      }
      <button
        appButton
        name="toggle-notifications"
        location="gallery-activity-menu"
        color="simple-gray-70"
        [hasIcon]="true"
        (click)="toggleNotifications()"
        height="0"
        spacing="1"
      >
        @if ((receiveNotifications$ | async) === true) {
          <app-svg size="0" [class.hidden-text]="markingAllAsSeen()" src="/assets/icons/bell-ringing.svg"></app-svg>
          <span>Subscribed</span>
        } @else {
          @if ((receiveNotifications$ | async) === false) {
            <app-svg
              size="0"
              [class.hidden-text]="markingAllAsSeen()"
              src="/assets/icons/bell-strikethrough.svg"
            ></app-svg>
            <span>Unsubscribed</span>
          } @else {
            <app-loading-indicator size="smaller"> </app-loading-indicator>
            <span>Loading...</span>
          }
        }
      </button>
    </div>
    @if (!loading() && !days().length) {
      <div class="no-activity">
        <img src="/assets/icons/special/bolt-dotted-disabled.svg" alt="" />
      </div>
    }
    @for (day of days(); track day) {
      <div class="day">
        @for (group of day.activityGroups; track group) {
          @if (group.link) {
            <a [routerLink]="group.link" [queryParams]="group.queryParams" [fragment]="group.fragment">
              <app-activity-group
                [group]="group"
                [day]="day"
                [seen]="isSeen(group)"
                [small]="true"
                [context]="'gallery'"
              >
              </app-activity-group>
            </a>
          }
          @if (!group.link) {
            <app-activity-group
              [group]="group"
              [day]="day"
              [seen]="isSeen(group)"
              (click)="clickGroup(group)"
              [small]="true"
            >
            </app-activity-group>
          }
        }
      </div>
    }
    @if (loading()) {
      <div class="loader">
        <app-loading-indicator></app-loading-indicator>
      </div>
    }
  </div>
</div>
